import type { Routes } from '@angular/router';
import { createMetaResolver, ngrxLoaderGuard, VehicleFeature } from '@hyundai/ng-common-lib';
import { vehicleProvider } from './pages/vehicles-page/vehicle.routes';

export const vehicleMarketRoutes: Routes = [
    {
        path: 'fahrzeugbestand',
        loadChildren: () => import('./pages/vehicles-page/vehicle.routes'),
    },
    {
        path: 'suchabo',
        loadChildren: () => import('./pages/searchabo-page/searchabo.routes'),
    },
    {
        path: 'favoriten',
        loadComponent: () => import('./pages/vehicles-page/favorites-page.component'),
        providers: [vehicleProvider],
        canActivate: [
            ngrxLoaderGuard({
                waitUntilLoadedSelector: VehicleFeature.vehicleState.selectIsLoadingFavorites,
                dataToCheckSelector: VehicleFeature.vehicleState.selectFavorites,
                actionToDispatch: (route) => VehicleFeature.vehicleActions.loadFavorites(),
            }),
        ],
        title: () => 'Favoriten',
        resolve: {
            meta: createMetaResolver(async (store, isHWS) => {
                return {
                    title: 'Favoriten',
                    description: 'Ihre Favoriten',
                    ogTitle: 'Favoriten',
                    ogDescription: 'Ihre Favoriten',
                    image: 'https://res.cloudinary.com/hmd-pw-dfnosvs4u/image/fetch/w_1200,h_630,c_fill,q_80,f_jpg/https://eu-central-1-shared-euc1-02.graphassets.com/cluk4akwq0hkd07w15cu50y0w/cmgyxx5anfril07uw6828wmhq',
                    imageAlt: 'Ihre Favoriten',
                    type: 'product',
                };
            }),
        },
    },
];
